<app-breadcrumb [master]="'OCK'" [parentName]="'Raporty'" [name]="'Firmy'"></app-breadcrumb>
<div class="ock-company-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="ock-company-list-filters">
  </form>

  <div class="ock-company-list-buttons">
    <button *ngIf="(userPermissions | async).ock.create" [disabled]="!(userPermissions | async)?.ock.create" mat-raised-button class="report-button" (click)="downloadReport()">
      <mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
  </div>

  <table mat-table [dataSource]="dataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Skrócona nazwa</th>
      <td mat-cell *matCellDef="let element">
        {{element.shortName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="nip">
      <th mat-header-cell *matHeaderCellDef> NIP </th>
      <td mat-cell *matCellDef="let element">
        {{ element.nip }}
      </td>
    </ng-container>

    <ng-container matColumnDef="regon">
      <th mat-header-cell *matHeaderCellDef> REGON </th>
      <td mat-cell *matCellDef="let element">
        {{element.regon}}
      </td>
    </ng-container>

    <ng-container matColumnDef="addres">
      <th mat-header-cell *matHeaderCellDef> Adres </th>
      <td mat-cell *matCellDef="let element">
        {{element.address }}
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>



